


























































































































































































































































































































































































































































import axios from 'axios';
import gql from 'graphql-tag';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import UiDropdown from '@/components/ui/UiDropdown.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiModal from '@/components/ui/UiModal.vue';
import UiSelect from '@/components/ui/UiSelect.vue';
import UiSelect2 from '@/components/ui/UiSelect2.vue';
import UiTextEdit from '@/components/ui/UiTextEdit.vue';
import { InventoryActionTypes } from '@/store/modules/inventories/types';

import { baConfig } from '../../../../config';
import {
  ApiSvcAssetValuationStrategies,
  ApiSvcGainLossSetupDTOTaxStrategyEnum,
  ApiSvcInventoryView,
  ApiSvcSpecificIdentificationCoinSpendingStrategy,
  ApiSvcSpecificIdentificationSelectionPreference,
  ApiSvcSpecificIdentificationSelectionStrategy,
  InventoryApi,
  LabelsApi,
} from '../../../../generated/api-svc';
import {
  ApiSvcImpairmentMethodology,
  AssetValuationStrategiesType,
  AssetValuationStrategiesTypeConfig,
  AssetValuationStrategyRequest,
  describeAssetValuationStrategies,
  impairmentMethodologiesKeys,
  impairmentStrategies,
  InventoryViewHelper,
  taxMethods,
  toAssetValuationStrategyRequests,
  toAssetValuationStrategyRows,
  valuationMethodologyOptions,
} from '../helpers/inventoryViewHelper';
import { INVENTORY_EFFECT_NAMES } from '../helpers/labelEffects';

@Component({
  components: {
    UiSelect,
    UiSelect2,
    UiDropdown,
    UiCheckbox,
    UiButton,
    UiTextEdit,
    UiLoading,
    UiModal,
  },
})
export default class InventoryViewSettings extends BaseVue {
  @Prop()
  public readonly currentView!: any;

  public isValidInput = false;
  public deleteName = '';
  public openDelete = false;
  public isDeleteing = false;
  public taxStrategy: ApiSvcGainLossSetupDTOTaxStrategyEnum = ApiSvcGainLossSetupDTOTaxStrategyEnum.Fifo;
  public defaultStrategy = ApiSvcAssetValuationStrategies.GaapFairValue;
  public expandAdvanced = false;
  public expandBasic = true;

  public labelDefinitions: { labelId: string; name: string }[] = [];
  public inventoryEffectTypes: { [key: string]: string } = INVENTORY_EFFECT_NAMES;

  loading = false;
  isEditable = false;
  editable = false;
  editingName = false;
  editedName = '';
  savingName = false;

  private actionButtons = {
    edit: {
      text: 'Edit View',
      icon: 'fa fa-pencil',
      color: 'primary',
    },
    save: {
      text: 'Save View',
      icon: 'fa fa-save',
      color: 'success',
    },
  };

  actionButton = this.actionButtons.edit;
  assetValuationStrategies: AssetValuationStrategiesType[] = [];
  assetValuationStrategiesConfig: AssetValuationStrategiesTypeConfig[] = [];
  valuationMethodologyOptions = valuationMethodologyOptions;

  // watch for changes in the current view and update the isEditable flag
  @Watch('currentView', { immediate: true })
  public onCurrentViewChange() {
    if (
      this.currentViewSafe.inventoryConfig &&
      this.currentViewSafe.inventoryConfig.assetValuationStrategies &&
      this.currentViewSafe.inventoryConfig.engineVersion >= 2
    ) {
      this.isEditable = true;
    } else {
      this.isEditable = false;
    }
  }

  getStrategy(key: string) {
    if (!key) return '';
    return impairmentStrategies[key as keyof typeof impairmentStrategies];
  }

  getStrategies(list: AssetValuationStrategyRequest[]) {
    if (!list?.length) return [];

    // load the strategies (with each coin's methodology, so saving the settings does not drop it)
    this.assetValuationStrategies = toAssetValuationStrategyRows(list);

    return describeAssetValuationStrategies(list);
  }

  public validate(valid: boolean) {
    this.isValidInput = this.currentView.name === this.deleteName;
  }

  public closeDelete() {
    this.openDelete = false;
    this.deleteName = '';
  }

  friendlyImpairment(val: ApiSvcImpairmentMethodology) {
    return impairmentMethodologiesKeys[val] ?? 'Unknown Method';
  }

  public get mapSpendingStrategy(): { spendingStrategy: string; selectionPreference: string }[] {
    return (
      this.currentView.inventoryPickingStrategy?.specificIdentificationStrategyRanges[0]
        ?.identificationStrategyRanked as ApiSvcSpecificIdentificationSelectionStrategy[]
    ).map((s) => {
      let spending: string;
      let preference: string;
      switch (s.spendingStrategy) {
        case ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_1:
          spending = 'Short Term Gain';
          break;
        case ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_3:
          spending = 'Long Term Gain';
          break;
        case ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_2:
          spending = 'Short Term Loss';
          break;
        default:
          spending = 'Long Term Loss';
          break;
      }
      switch (s.selectionPreference) {
        case ApiSvcSpecificIdentificationSelectionPreference.NUMBER_1:
          preference = 'Minimize';
          break;
        default:
          preference = 'Maximize';
          break;
      }
      return {
        spendingStrategy: spending,
        selectionPreference: preference,
      };
    });
  }

  get inventoryGroups() {
    return this.$store.getters['inventories/INVENTORY_GROUPS'];
  }

  get inventoryGroupName() {
    return (
      this.inventoryGroups.find(
        (x: any) => x.id === this.currentViewSafe?.inventoryConfig?.inventoryMappingRule?.inventoryMappingId
      )?.name ?? 'None'
    );
  }

  get currentViewSafe(): any {
    const retVal = { ...this.currentView };
    if (!retVal.inventoryPickingStrategy) {
      retVal.inventoryPickingStrategy = {};
    }
    if (!retVal.inventoryConfig) {
      retVal.inventoryConfig = {};
    }
    if (!retVal.inventoryConfig.inventoryMappingRule) {
      retVal.inventoryConfig.inventoryMappingRule = {};
    }
    return retVal;
  }

  public async deleteView() {
    this.isDeleteing = true;
    this.openDelete = false;

    try {
      const orgId = this.$store.state.currentOrg.id;
      const svc = new InventoryApi(undefined, baConfig.getFriendlyApiUrl());

      const resp = await svc.deleteView(orgId, this.currentView.id ?? '', {
        withCredentials: true,
      });

      if (resp.status !== 204) {
        throw new Error('Failed to delete view');
      }

      this.$emit('refresh-views');
    } finally {
      this.isDeleteing = false;
    }
  }

  async refreshInventoriesAndGroups() {
    return await this.$store.dispatch('inventories/' + InventoryActionTypes.GET_INVENTORIES, {
      orgId: this.$store.state.currentOrg.id,
    });
  }

  async mounted() {
    await this.refreshInventoriesAndGroups();
    if ((this.currentView?.strategyOverrides ?? []).length > 0) {
      await this.$store.dispatch('wallets/getWallets', this.$store.state.currentOrg.id);
    }
    if (this.checkFeatureFlag('custom-labels')) {
      await this.loadLabelDefinitions();
    }
  }

  private async loadLabelDefinitions() {
    try {
      const orgId = this.$store.state.currentOrg.id;
      const svc = new LabelsApi(undefined, baConfig.getFriendlyApiUrl());
      const resp = await svc.getOrgLabelDefinitions(
        orgId,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        {
          withCredentials: true,
        }
      );
      if (resp.data?.items) {
        this.labelDefinitions = resp.data.items as any;
      }
    } catch (e) {
      console.error('Failed to load label definitions', e);
    }
  }

  get hasActiveLabelEffects(): boolean {
    const effects = this.currentViewSafe.inventoryConfig?.activeLabelEffects;
    return effects && Object.keys(effects).length > 0;
  }

  get formatActiveLabelEffects(): string {
    const effects = this.currentViewSafe.inventoryConfig?.activeLabelEffects;
    if (!effects) return '';
    return Object.entries(effects)
      .map(([labelId, effectType]) => {
        const label = this.labelDefinitions.find((d) => d.labelId === labelId);
        const labelName = label?.name || labelId;
        const effectName = this.inventoryEffectTypes[effectType as string] || effectType;
        return `${labelName} (${effectName})`;
      })
      .join(', ');
  }

  async resetActions() {
    this.editable = false;
    this.actionButton = this.actionButtons.edit;
  }

  startNameEdit() {
    this.editingName = true;
    this.editedName = this.currentViewSafe.name;
  }

  cancelNameEdit() {
    this.editingName = false;
    this.editedName = '';
  }

  async saveNameEdit() {
    if (!this.editedName || this.editedName.trim().length === 0) {
      return;
    }

    this.savingName = true;
    try {
      const orgId = this.$store.state.currentOrg.id;
      const url = `${baConfig.getFriendlyApiUrl()}/orgs/${orgId}/inventory-views/${this.currentView.id}`;

      const resp = await axios.patch(url, { name: this.editedName, allowUpdate: true }, { withCredentials: true });

      if (resp.status === 200) {
        this.$set(this.currentView, 'name', this.editedName);
        this.editingName = false;
        this.editedName = '';
        this.showSuccessSnackbar('View name updated successfully');
        this.$emit('refresh-views');
      } else {
        this.showErrorSnackbar('Failed to update view name');
      }
    } catch (error: any) {
      console.error('Error updating view name:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update view name';
      this.showErrorSnackbar(errorMessage);
    } finally {
      this.savingName = false;
    }
  }

  public get valuationStrategies() {
    if (this.checkFeatureFlag('mark-to-market-no-fmv-rollback')) {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('mark-to-market-no-fmv-rollback');
    } else if (this.checkFeatureFlag('impairment')) {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('impairment');
    } else {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('default');
    }
  }

  public getPickingStrategy(type: number): string {
    return taxMethods[type as keyof typeof taxMethods];
  }

  // Overrides are keyed by walletId on per-wallet views and inventoryId on
  // group-mapped views; resolve whichever matches, falling back to the raw id.
  public strategyOverrideTargetName(id: string): string {
    const wallets: { id?: string; name?: string }[] = this.$store.getters['wallets/WALLETS'] ?? [];
    const wallet = wallets.find((w) => w?.id === id);
    if (wallet?.name) return wallet.name;
    const inventories: { id?: string; name?: string }[] = this.$store.getters['inventories/INVENTORIES'] ?? [];
    const inventory = inventories.find((inv) => inv?.id === id);
    return inventory?.name ?? id;
  }

  public getFairMarketValueResolution(resolution: string): string {
    if (!resolution) return 'Org Default';
    const resolutionMap: { [key: string]: string } = {
      '15m': '15 Minutes',
      '1h': '1 Hour',
      '1d': '1 Day',
      t15m: 'T15 Minutes',
      t1h: 'T1 Hour',
      t1d: 'T1 Day',
    };
    return resolutionMap[resolution] || resolution;
  }

  public getFairMarketValueMethodology(methodology: string): string {
    if (!methodology) return 'Org Default';
    const methodologyMap: { [key: string]: string } = {
      close: 'Close',
      vwap: 'VWAP',
      low: 'Low',
      open: 'Open',
      high: 'High',
    };
    return methodologyMap[methodology] || methodology;
  }

  private async validateTickers() {
    // Check if the tickers are valid
    const resp = await new InventoryViewHelper().validateTickers(this.assetValuationStrategies);
    if (resp && !resp.status) {
      this.showErrorSnackbar(resp.msg);
      return false;
    }

    if (resp.data) {
      this.assetValuationStrategiesConfig = resp.data;
    }

    return true;
  }

  private async updateViewSettings(inventoryViewSettings: ApiSvcInventoryView) {
    // update by using the GraphQL API
    const vars = {
      orgId: this.$store.state.currentOrg.id,
      inventoryId: this.currentView.id,
      inventoryConfig: {
        assetValuationStrategies: this.assetValuationStrategiesConfig,
      },
    };

    // updateInventoryConfig
    return await this.$apollo.mutate({
      mutation: gql`
        mutation ($orgId: ID!, $inventoryId: ID!, $inventoryConfig: InventoryViewConfigInput!) {
          updateInventoryViewConfig(orgId: $orgId, inventoryId: $inventoryId, inventoryConfig: $inventoryConfig) {
            success
            errors
          }
        }
      `,
      variables: vars,
    });
  }

  async submitChange(event: Event) {
    event.preventDefault();

    if (this.actionButton.text === 'Edit View') {
      this.actionButton = {
        ...this.actionButtons.save,
      };

      this.editable = true;
    } else {
      // simulate save of view
      this.loading = true;
      this.actionButton.text = 'Saving...';

      const validationResp = await this.validateTickers();
      if (!validationResp) {
        this.loading = false;
        this.actionButton.text = 'Save View'; // reset state
        return;
      }

      // update in real time
      this.currentViewSafe.inventoryConfig.assetValuationStrategies = toAssetValuationStrategyRequests(
        this.assetValuationStrategies
      );

      // call mutation to update view settings
      const resp = (await this.updateViewSettings(this.currentViewSafe)).data;
      if (resp.updateInventoryViewConfig.errors.length > 0) {
        this.showErrorSnackbar('Failed to save view');
        this.loading = false;
        this.actionButton.text = 'Save View'; // reset state
        return;
      }

      setTimeout(() => {
        this.actionButton = {
          ...this.actionButtons.edit,
        };

        this.editable = false;
        this.loading = false;
        this.showSuccessSnackbar(`View saved successfully [${this.currentViewSafe.name}]`);
      }, 500);
    }
  }
}
